// Scrollspy for the legal-page TOC. Highlights the link whose section is
// nearest the top of the viewport. Smooth scroll is handled in CSS.

export function initLegalToc() {
  const toc = document.querySelector( '.legal-toc' );
  if ( ! toc ) return;

  const links = Array.from( toc.querySelectorAll( 'a[data-toc-target]' ) );
  const linkById = new Map( links.map( ( l ) => [ l.dataset.tocTarget, l ] ) );
  const sections = links
    .map( ( l ) => document.getElementById( l.dataset.tocTarget ) )
    .filter( Boolean );

  if ( ! sections.length ) return;

  const setActive = ( id ) => {
    links.forEach( ( l ) => l.classList.toggle( 'is-active', l.dataset.tocTarget === id ) );
  };

  const observer = new IntersectionObserver(
    ( entries ) => {
      const visible = entries
        .filter( ( e ) => e.isIntersecting )
        .sort( ( a, b ) => a.target.offsetTop - b.target.offsetTop );

      if ( visible.length ) setActive( visible[0].target.id );
    },
    {
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0,
    }
  );

  sections.forEach( ( s ) => observer.observe( s ) );
  setActive( sections[0].id );
}
